module.exports = __webpack_public_path__ + "img/r2.ef149277.jpg";